import styled from 'styled-components';

const HelpText = styled.span`
  font-size: 0.8em;
  font-family: inherit;
  font-style: italic
`;

export default HelpText;



// WEBPACK FOOTER //
// ./app/components/HelpText/index.js